export default __webpack_public_path__ + "static/media/declaracion-jurada.7c0c6e82.png";